/**
 * Sections Store
 * Zustand store for managing sections state
 */

import { create } from 'zustand';
import { 
  fetchSections as fetchSectionsAPI, 
  deleteSection as deleteSectionAPI,
  createSection as createSectionAPI,
  updateSection as updateSectionAPI
} from '../services/sections.service';
import type { SectionsStore } from '../interfaces/storeInterfaces/sectionsStore';
import type { CreateSectionRequest, UpdateSectionRequest } from '../interfaces/apiInterfaces/sections';

export const useSectionsStore = create<SectionsStore>((set) => ({
  sections: [],
  pagination: null,
  isLoading: false,
  error: null,

  fetchSections: async (params) => {
    set({ isLoading: true, error: null });
    try {
      const response = await fetchSectionsAPI(params);
      
      // Log the API response
      console.log('=== Sections API Response ===');
      console.log('Full Response:', response);
      console.log('Data (Sections):', response.data);
      console.log('Pagination:', response.pagination);
      console.log('Total Sections:', response.data.length);
      console.log('============================');
      
      set({
        sections: response.data,
        pagination: response.pagination,
        isLoading: false,
      });
    } catch (error) {
      console.error('=== Sections API Error ===');
      console.error('Error:', error);
      console.error('=========================');
      set({
        error: error instanceof Error ? error.message : 'Failed to fetch sections',
        isLoading: false,
      });
    }
  },

  deleteSection: async (sectionId) => {
    try {
      await deleteSectionAPI(sectionId);
      // Remove the deleted section from the local state
      set((state) => ({
        sections: state.sections.filter((section) => section.section_id !== sectionId),
      }));
    } catch (error) {
      console.error(`Failed to delete section ${sectionId}:`, error);
      throw error;
    }
  },

  createSection: async (data: CreateSectionRequest) => {
    try {
      console.log('CreateSectionRequest ', data);
      const response = await createSectionAPI(data);
      console.log('=== Section Created Successfully ===');
      return response;
    } catch (error) {
      console.error('Failed to create section:', error);
      throw error;
    }
  },

   updateSection: async (sectionid : string ,data: UpdateSectionRequest) => {
    try {
      console.log('UpdateSectionRequest ', data);
      const response = await updateSectionAPI(sectionid,data);
      console.log('=== Section Updated Successfully ===');
      return response;
    } catch (error) {
      console.error('Failed to update section:', error);
      throw error;
    }
  },

  reset: () => {
    set({
      sections: [],
      pagination: null,
      isLoading: false,
      error: null,
    });
  },
}));

